import { useCallback, useEffect, useState } from 'react';
import { listOpenQuotations } from '../api';
import { normalizePaginatedResponse } from '../utils/pagination';
import usePurchaseEvents from './usePurchaseEvents';

const OPEN_QUOTATION_EVENTS = new Set([
  'quotation-created',
  'quotation-updated',
  'quotation-deleted',
  'quotation-sent',
  'quotation-accepted',
]);

const useOpenQuotations = (branchId, options = {}) => {
  const { enableRealtime = true } = options;
  const [quotations, setQuotations] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchOpenQuotations = useCallback(async () => {
    if (!branchId) return;
    setLoading(true);
    setError(null);
    try {
      const result = await listOpenQuotations(branchId);
      const normalized = normalizePaginatedResponse(result);
      const filtered = (normalized.data || []).filter(
        (quotation) =>
          !quotation?.isDeleted
          && String(quotation?.status || '').toLowerCase() === 'draft'
      );
      setQuotations(filtered);
    } catch (err) {
      console.error('Error fetching open quotations:', err);
      setError(err);
    } finally {
      setLoading(false);
    }
  }, [branchId]);

  useEffect(() => {
    fetchOpenQuotations();
  }, [fetchOpenQuotations]);

  usePurchaseEvents(
    branchId,
    (data) => {
      if (enableRealtime && data && OPEN_QUOTATION_EVENTS.has(data.type)) {
        fetchOpenQuotations();
      }
    },
    { enabled: !!branchId }
  );

  return {
    quotations,
    loading,
    error,
    reload: fetchOpenQuotations,
  };
};

export default useOpenQuotations;
export { OPEN_QUOTATION_EVENTS };
